function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.6946 26.7757L17.9509 2.9711C17.5437 2.26579 16.8144 1.84473 16 1.84473C15.1856 1.84473 14.4563 2.26579 14.0491 2.9711L0.305438 26.7757C-0.101812 27.481 -0.101812 28.3232 0.305438 29.0285C0.712625 29.7338 1.44194 30.1548 2.25638 30.1548H29.7436C30.5581 30.1548 31.2874 29.7338 31.6946 29.0285C32.1018 28.3232 32.1018 27.481 31.6946 26.7757ZM30.0688 28.0898C30.0284 28.16 29.9322 28.2776 29.7437 28.2776H2.25638C2.06775 28.2776 1.97162 28.16 1.93125 28.0898C1.89081 28.0198 1.83694 27.8777 1.93125 27.7144L15.6748 3.90973C15.7691 3.74641 15.919 3.72198 15.9999 3.72198C16.0809 3.72198 16.2308 3.74635 16.3251 3.90973L30.0688 27.7144C30.1631 27.8777 30.1093 28.0198 30.0688 28.0898Z",
  fill: "#FF5B4A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9391 10.3809H15.0618V20.3932H16.9391V10.3809Z",
  fill: "#FF5B4A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0003 24.7736C16.6916 24.7736 17.2519 24.2133 17.2519 23.5221C17.2519 22.8309 16.6916 22.2705 16.0003 22.2705C15.3091 22.2705 14.7488 22.8309 14.7488 23.5221C14.7488 24.2133 15.3091 24.7736 16.0003 24.7736Z",
  fill: "#FF5B4A"
});

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.81182d92.svg";
export { ForwardRef as ReactComponent };